import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'
import MaskedInput from 'react-text-mask'
import classnames from 'classnames/bind'
import { Dropdown, Input, Icon, constants, utils } from '@adc/ui-core'
import { DEBOUNCE_WAIT_FOR_SEARCH_TYPING } from '../constants/statics'
import { DATE_OPTIONS, DATE_OPTION_TYPES } from '../constants'
import DatePicker from './datePicker'
import styles from './styles.scss'

// TODO: BOOM
//
// This doesn't seem to be building correctly in latest node-core-modules.
//
// import { NumberRange } from '@adc/structures/range'
class NumberRange {
  static isValidString(val) {
    return true
  }
}

const cx = classnames.bind(styles)
const { TIME_SYNTAX } = constants.regex
const { createAutoCorrectionTimePipe } = utils
const { UI_DATE_FORMAT } = constants.statics

const ALL_COLUMNS_VALUE = '*'
const ALL_COLUMNS = { value: ALL_COLUMNS_VALUE, text: 'All Columns' }
const INCLUDES_VALUE = 'EQUALS'
const INCLUDES_COLUMNS = { value: INCLUDES_VALUE, text: 'Includes' }
const PLACEHOLDER = 'Add a Filter or Search...'
const INITIAL_STATE = {
  dropdownClosed: true,
  searchValues: [],
  searchQuery: '',
  searchColumn: ALL_COLUMNS,
  operationColumn: INCLUDES_COLUMNS,
  operationOptions: [],
  operationValue: INCLUDES_COLUMNS.value,
  operationOpen: false,
  operationValueAsText: '',
  valuesAsText: '',
  showSearchHelp: false,
  suggestionOptions: [],
  suggestionOpen: false,
  isLoading: false,
}
const DATA_TYPES = {
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  DATE: 'DATE',
  DATE_AS_ISO: 'DATE_AS_ISO',
  DATETIME: 'DATETIME',
  DATETIME_AS_LOCAL: 'DATETIME_AS_LOCAL',
  NUMBER_RANGE: 'NUMBER_RANGE',
  GROUPED_ARRAY: 'GROUPED_ARRAY',
  TIME: 'TIME',
}

const COMPARISON_TYPES = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
}

const OPERATION_TYPES = {
  COMPARISON: COMPARISON_TYPES,
}

const NON_ALL_COLUMNS_TYPES = [
  DATA_TYPES.BOOLEAN,
  DATA_TYPES.NUMBER,
  DATA_TYPES.DATE,
  DATA_TYPES.DATE_AS_ISO,
  DATA_TYPES.DATETIME_AS_LOCAL,
  DATA_TYPES.DATETIME,
]
const SEARCH_TYPES = {
  TEXT: 'TEXT',
  SUGGEST_SYNC: 'SUGGEST_SYNC', // for simple option lists defined in code
  SUGGEST_ASYNC: 'SUGGEST_ASYNC', // for advanced options lists that require a fetch
  SUGGEST_ASYNC_ONE_TIME: 'SUGGEST_ASYNC_ONE_TIME',
  DATE: 'DATE',
  DATE_RANGE: 'DATE_RANGE',
  TIME: 'TIME',
  NUMBER_RANGE: 'NUMBER_RANGE',
}
const LOOKUP_TYPES = {
  USER: 'USER',
}

const keys = {
  ENTER: 13,
}

const UPDATE_DEBOUNCE_MS = 50

class SearchField extends Component {
  constructor(props) {
    super(props)

    /**
     * This is a hack to address this issue with Chrome and the semantic-ui-react dropdown:
     * https://github.com/Semantic-Org/Semantic-UI-React/issues/4489
     *
     * Basically, with the bug we get two calls to this method in succession, the second of
     * which has the wrong value.  This debounce ensures we only use the first value.
     */
    this.updateClauseFromDropdown = this.updateClauseFromDropdown.bind(this)
    this.debouncedUpdateClauseFromDropdown = _.debounce(
      this.updateClauseFromDropdown,
      UPDATE_DEBOUNCE_MS,
      {
        leading: true,
        trailing: false,
      }
    )
  }

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    filterColumns: PropTypes.array.isRequired,
    clauses: PropTypes.array.isRequired, // used to know what is currently in search clauses
    suggestions: PropTypes.object,
    updateSuggestions: PropTypes.func,
    minCharsForAsyncSuggestions: PropTypes.number,
    enableOperationSelection: PropTypes.bool,
  }

  static defaultProps = {
    suggestions: {},
    updateSuggestions: _.noop,
    minCharsForAsyncSuggestions: 1,
    enableOperationSelection: false,
  }

  state = INITIAL_STATE

  // a little hacky, but this ensures we work with both old and new versions of refs
  getRef = ref => ref && (ref.current || ref)

  /**
   * Returns true if literally CALENDAR mode or if it's a specific date
   * (based on it being not one of the other types.)
   * @param {Array} values
   */
  isCalendarModeSelected = values =>
    !(
      values.length &&
      _.pull(
        Object.values(DATE_OPTION_TYPES),
        DATE_OPTION_TYPES.CALENDAR
      ).includes(values[0])
    )

  searchComponentRef = searchComponent => {
    this.searchComponent =
      searchComponent && searchComponent.searchRef
        ? this.getRef(searchComponent.searchRef)
        : searchComponent
  }

  onDropdownOpen = _ => {
    this.setState({ dropdownClosed: false })
  }

  onDropdownClose = _ => {
    this.setState({ dropdownClosed: true })
  }

  componentDidUpdate = prevProps => {
    if (!_.isEqual(prevProps.clauses, this.props.clauses)) {
      this.getCurrentClauseValues()
    }

    if (
      !_.isEqual(
        prevProps.suggestions.suggestionData,
        this.props.suggestions.suggestionData
      )
    ) {
      this.getSuggestionOptions()
    }
  }

  /**
   * Gets the current values from the current clauses state so we can initialize
   * the component with the current values.
   */
  getCurrentClauseValues = (callback = _.noop) => {
    const { clauses } = this.props
    const { searchColumn } = this.state
    const curClause = _.find(
      clauses,
      clause => clause.title === searchColumn.text
    )
    this.setState(
      {
        searchValues: curClause ? curClause.values : [],
        valuesAsText: curClause ? curClause.valuesAsText : '',
      },
      callback
    )
  }

  /**
   * This turns a single value into an option if necessary. The user never sees this in the list, this is just
   * to keep the select happy so it doesn't remove the selected item from the input.
   */
  valueToOption = (item, isTemporary) => {
    if (_.isObject(item)) return item
    const newItem = { value: item, text: item }
    if (isTemporary) {
      newItem.style = { display: 'none' }
    }
    return newItem
  }

  /**
   * Sets up the suggestion options.
   *
   */
  getSuggestionOptions = () => {
    const { searchColumn, searchValues } = this.state
    let options = []

    if (searchColumn.searchType === SEARCH_TYPES.SUGGEST_SYNC) {
      options = searchColumn.options
    } else if (searchColumn.searchType === SEARCH_TYPES.DATE) {
      options = DATE_OPTIONS
    } else if (
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC ||
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME
    ) {
      const { suggestionData = {} } = this.props.suggestions
      const suggestions = suggestionData[searchColumn.value] || []

      if (searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC) {
        /**
         * Options must include the currently selected values as well or else
         * the dropdown control will remove those values when you search on something
         * else or switch to another fields and return.
         */
        options = searchValues
          .map(v => this.valueToOption(v, true))
          .concat(suggestions.map(v => this.valueToOption(v, false)))
        options = _.uniqWith(options, (val1, val2) => val1.value === val2.value)
      } else {
        options = suggestions
      }
    }

    this.setState({ suggestionOptions: options })
  }

  getOperationOptions = () => {
    const { searchColumn } = this.state
    let options = []
    if (searchColumn.operationType) {
      options = searchColumn.operationOptions
        .map(operationOption => {
          return (
            searchColumn.operationType[operationOption.value] && operationOption
          )
        })
        .filter(operation => operation !== undefined)
    }

    this.setState({ operationOptions: options, operationColumn: options[0] })
  }

  updateColumn = async (event, { value }) => {
    const { filterColumns, updateSuggestions } = this.props
    const searchColumn = _.find(filterColumns, { value }) || ALL_COLUMNS

    // If async, we need want to start fresh (without a prior suggestions list)
    if (searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC) {
      await updateSuggestions({
        text: '',
        fields: [value],
      })
    }

    this.setState({ searchColumn }, () => {
      this.getCurrentClauseValues(() => {
        this.getSuggestionOptions()
        this.getOperationOptions()
        this.focusInput()
      })
    })
  }

  updateOperationColumn = (event, { value }) => {
    const { searchColumn } = this.state
    const searchOperation = _.find(searchColumn.operationOptions, {
      value,
    }) || [INCLUDES_COLUMNS]

    this.setState(
      {
        operationColumn: searchOperation,
        operationValueAsText: searchOperation.value,
      },
      () => {
        this.getCurrentClauseValues(() => {
          this.focusInput()
        })
      }
    )
  }

  updateClause = (event, onUpdate) => {
    this.setState(
      {
        searchValues: [event.target.value],
        valuesAsText: event.target.value,
      },
      () => (_.isFunction(onUpdate) ? onUpdate() : undefined)
    )
  }

  /**
   * Gets the values and text for each value (as a composite string) so we can display
   * it to the user.  Always track values as an array - even if just one.
   */
  updateClauseFromDropdown = (event, data) => {
    const { searchColumn } = this.state
    // bail if shift-enter, in which case we want to search, not select another value
    if (event.shiftKey && event.which === keys.ENTER) return

    const values = Array.isArray(data.value) ? data.value : [data.value]

    const valuesAsText = _.filter(data.options, option =>
      data.value.includes(option.value)
    )
      .map(option => option.text)
      .join(', ')

    this.setState(
      {
        searchValues: values,
        valuesAsText,
      },
      () => {
        // if not in calendar mode, just go ahead and search
        // else give focus to calendar picker
        if (searchColumn.searchType === SEARCH_TYPES.DATE) {
          if (!this.isCalendarModeSelected(values)) {
            this.submit({ type: 'click' })
          } else {
            const today = moment().format(UI_DATE_FORMAT)
            this.setState({ searchValues: [today], valuesAsText: today })
            _.defer(this.focusInput)
            this.focusInput()
          }
        }
      }
    )
  }

  selectSearchValue = () => {
    const regularInput = this.getRef(this.searchComponent.inputRef)
    const dateInput =
      !this.searchComponent.overlayHasFocus &&
      this.searchComponent.handleInputBlur
    if (regularInput) {
      this.searchComponent.focus()
      regularInput.setSelectionRange(0, regularInput.value.length)
    } else if (dateInput) {
      this.searchComponent.handleInputBlur()
    }
  }

  closeSuggestionDropdown = () => {
    this.setState({ suggestionOpen: false })
  }

  openSuggestionDropdown = () => {
    this.setState({ suggestionOpen: true })
  }

  closeOperationDropdown = () => {
    this.setState({ operationOpen: false })
  }

  openOperationDropdown = () => {
    this.setState({ operationOpen: true })
  }

  focusInput = () => {
    const { dropdownClosed } = this.state

    if (dropdownClosed && typeof this.searchComponent.focus !== 'undefined') {
      this.searchComponent.focus()
      this.selectSearchValue()
    } else if (
      dropdownClosed &&
      typeof this.searchComponent.handleInputFocus !== 'undefined'
    ) {
      this.searchComponent.handleInputFocus()
    } else if (
      dropdownClosed &&
      typeof this.searchComponent.inputElement.focus !== 'undefined'
    ) {
      this.searchComponent.inputElement.focus()
    }
  }

  getValues = (searchValues, searchColumn) => {
    if (searchColumn.dataType === DATA_TYPES.GROUPED_ARRAY) {
      return _.map(searchValues, val => val.split(','))
    } else {
      return _.filter(
        _.map(searchValues, val =>
          typeof val === 'boolean' ? val : _.trim(val)
        ),
        val => (typeof val === 'boolean' ? true : _.identity)
      )
    }
  }

  submit = (event, useShiftEnter = false) => {
    const { searchValues, searchColumn, valuesAsText, operationColumn } =
      this.state
    const values = this.getValues(searchValues, searchColumn)
    const searchOperation = _.isNil(operationColumn)
      ? OPERATION_TYPES.COMPARISON.EQUALS
      : operationColumn.value

    // Just die on invalid values. No feedback or anything.
    if (
      searchColumn.searchType === SEARCH_TYPES.NUMBER_RANGE &&
      !NumberRange.isValidString(valuesAsText)
    ) {
      return
    }

    if (
      searchColumn.searchType === SEARCH_TYPES.TIME &&
      !TIME_SYNTAX.test(valuesAsText)
    ) {
      return
    }

    if (
      event.type === 'click' ||
      (event.keyCode === keys.ENTER && (useShiftEnter ? event.shiftKey : true))
    ) {
      const { filterColumns } = this.props
      // Boolean columns only applicable for single field search using SUGGEST_SYNC,
      // hence omit them when searching on all columns
      const fields =
        searchColumn.value === ALL_COLUMNS_VALUE
          ? _.filter(
              filterColumns,
              col => !NON_ALL_COLUMNS_TYPES.includes(col.dataType)
            )
          : [searchColumn]
      const partialMatchFields = _.compact(
        fields.map(col => (col.partialMatch ? col.value : null))
      )
      const searchFields = fields.reduce(
        (newFields, field) => [...newFields, field.value],
        []
      )

      const searchTitle = _.isNil(operationColumn)
        ? `${searchColumn.text}`
        : `${searchColumn.text} ${operationColumn.text}`

      this.props.onSubmit({
        fields: searchFields,
        title: searchTitle,
        dataType: searchColumn.dataType,
        values,
        valuesAsText,
        partialMatchFields,
        searchOperation,
        setMatch: searchColumn.setMatch,
        searchAnalyzer: searchColumn.searchAnalyzer,
        sortAnalyzer: searchColumn.sortAnalyzer,
      })
      this.selectSearchValue()
      if (
        searchColumn.searchType === SEARCH_TYPES.SUGGEST_SYNC ||
        searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC ||
        searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME ||
        searchColumn.searchType === SEARCH_TYPES.DATE
      ) {
        this.closeSuggestionDropdown()
      }
    }
  }

  renderSearchComponent = () => {
    const { searchColumn } = this.state

    if (
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_SYNC ||
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC ||
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME
    ) {
      return this.renderDropdown()
    } else if (searchColumn.searchType === SEARCH_TYPES.DATE) {
      return this.renderDate()
    } else if (searchColumn.searchType === SEARCH_TYPES.TIME) {
      return this.renderTime()
    } else {
      return this.renderInput()
    }
  }

  renderTime = () => {
    const timeSpecificMask = [
      /\d/,
      /\d/,
      ':',
      /[0-5]/,
      /\d/,
      ' ',
      /[aApP]/,
      'M',
    ]

    return (
      <Input className={`icon ${cx('search-input')}`}>
        <MaskedInput
          ref={this.searchComponentRef}
          className={cx('masked-input')}
          data-elm-id='search_time_input'
          mask={timeSpecificMask}
          placeholder='Ex. 09:00 AM'
          pipe={createAutoCorrectionTimePipe()}
          onChange={this.updateClause}
          value={this.state.valuesAsText}
          onKeyUp={this.submit}
        />
        <Icon
          name='search'
          color='info'
          link
          onClick={this.submit}
          data-elm-id='search_icon'
        />
      </Input>
    )
  }

  areDatesPresent = values => values.length

  renderDate = () => {
    const { searchValues: values } = this.state
    return this.areDatesPresent(values) && this.isCalendarModeSelected(values)
      ? this.renderDatePicker()
      : this.renderDropdown()
  }

  clearSearchValue = () => {
    this.setState({ searchValues: [], valuesAsText: '' }, () => {
      this.focusInput()
    })
  }

  onDatePickerInputChange = e => {
    const value = e.target.value.trim()
    if (value === '') {
      this.clearSearchValue()
    }
  }

  renderDatePicker = () => {
    return (
      <DatePicker
        searchValue={this.state.valuesAsText}
        getRef={this.searchComponentRef}
        searchRef={this.searchComponent}
        updateClause={this.updateClause}
        submit={this.submit}
        onInputChange={this.onDatePickerInputChange}
        onClear={this.clearSearchValue}
      />
    )
  }

  renderInput = () => {
    const { searchValues } = this.state
    const value = searchValues.length ? searchValues[0] : ''

    return (
      <Input
        className={cx('search-input')}
        icon={{
          name: 'search',
          link: true,
          onClick: this.submit,
          'data-elm-id': 'search_icon',
        }}
        ref={this.searchComponentRef}
        data-elm-id='search_input'
        placeholder={PLACEHOLDER}
        onChange={this.updateClause}
        onKeyUp={this.submit}
        value={value}
      />
    )
  }

  showSearchHelp = _.debounce(bShow => {
    this.setState({ showSearchHelp: bShow })
  })

  /**
   * This ultimately dispatches an action to query the suggest API (ES).  Note that currently
   * we only handle single-field suggestions because this component does not yet "know" about
   * ALL_COLUMNS in terms of what all those fields are.  In future we can enhance this
   * to pass in all the fields for this query - but for now this will suffice.
   */
  onSearchChange = _.debounce(async (event, data) => {
    const { updateSuggestions, minCharsForAsyncSuggestions } = this.props
    const { searchColumn } = this.state

    this.setState({ searchQuery: data.searchQuery })

    if (searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC) {
      if (data.searchQuery.length >= minCharsForAsyncSuggestions) {
        this.setState({ isLoading: true })
        await updateSuggestions({
          text: data.searchQuery,
          fields: [searchColumn.value],
        })
        this.setState({ isLoading: false })
      }
    }
  }, DEBOUNCE_WAIT_FOR_SEARCH_TYPING)

  customSearch = (filteredOptions, searchQuery) => {
    // Default is to just search strictly against complete matches, not substrings, which affects dropdown options shown
    // Override by calling this function to return the BE data which checks for partial matches
    return filteredOptions
  }

  isMultipleSelect = searchType => searchType !== SEARCH_TYPES.DATE

  renderDropdown = () => {
    const {
      searchColumn,
      searchValues,
      suggestionOptions,
      showSearchHelp,
      suggestionOpen,
      isLoading,
    } = this.state
    const customSearch =
      searchColumn.searchType === SEARCH_TYPES.SUGGEST_ASYNC
        ? this.customSearch
        : true
    let formattedSuggestionOptions = suggestionOptions

    if (searchColumn.dataType === DATA_TYPES.GROUPED_ARRAY) {
      formattedSuggestionOptions = suggestionOptions.map(o => {
        o.value = Array.isArray(o.value) ? o.value.join(',') : o.value
        return o
      })
    }

    const value =
      !this.isMultipleSelect(searchColumn.searchType) &&
      Array.isArray(searchValues) &&
      searchValues.length
        ? searchValues[0]
        : searchValues

    return (
      <div className={cx('search-suggest-container')}>
        <Dropdown
          className={`${cx('search-suggest', {
            multiple: this.isMultipleSelect(searchColumn.searchType),
          })} compact`}
          ref={this.searchComponentRef}
          data-elm-id='search_suggest'
          placeholder='Select Values'
          multiple={this.isMultipleSelect(searchColumn.searchType)}
          selection
          loading={isLoading}
          search={customSearch}
          options={formattedSuggestionOptions}
          onSearchChange={this.onSearchChange}
          onChange={this.debouncedUpdateClauseFromDropdown}
          value={value}
          onKeyUp={e => {
            this.submit(e, true)
          }}
          onClick={() => {
            this.searchComponent.focus()
          }}
          onBlur={this.closeSuggestionDropdown}
          onFocus={this.openSuggestionDropdown}
          onOpen={this.openSuggestionDropdown}
          open={suggestionOpen}
          openOnFocus={false}
          icon={{
            className: cx('search-icon'),
            name: 'search',
            link: true,
            onClick: this.submit,
            onMouseEnter: () => {
              this.showSearchHelp(true)
            },
            onMouseLeave: () => {
              this.showSearchHelp(false)
            },
            'data-elm-id': 'search_icon',
          }}
        />
        <div className={cx('search-help', { hide: !showSearchHelp })}>
          shift-enter to add
        </div>
      </div>
    )
  }

  renderOperationDropdown = () => {
    const { operationOptions, operationColumn, operationOpen } = this.state
    const options = operationOptions.length ? operationOptions : []
    const operationDropDown = options.length ? (
      <Dropdown
        className={`${cx('operation-selector')} compact`}
        search
        selection
        data-elm-id='operation_dropdown'
        onChange={this.updateOperationColumn}
        onClose={this.closeOperationDropdown}
        onOpen={this.openOperationDropdown}
        open={operationOpen}
        value={operationColumn.value}
        options={options}
      />
    ) : null

    return operationDropDown
  }

  render() {
    const { filterColumns, enableOperationSelection } = this.props
    const { searchColumn } = this.state

    // semantic throws a proptype warning if we include partialmatch
    const formattedFilterCols = filterColumns.map(item => ({
      value: item.value,
      text: item.text,
    }))

    return (
      !_.isEmpty(filterColumns) && (
        <div className={cx('search-container')}>
          <Dropdown
            className={`${cx('field-selector')} compact`}
            search
            selection
            data-elm-id='search_dropdown'
            onChange={this.updateColumn}
            onClose={this.onDropdownClose}
            onOpen={this.onDropdownOpen}
            value={searchColumn.value}
            options={[ALL_COLUMNS, ...formattedFilterCols]}
          />
          {enableOperationSelection && this.renderOperationDropdown()}
          {this.renderSearchComponent()}
        </div>
      )
    )
  }
}

export default SearchField
export { DATA_TYPES, SEARCH_TYPES, LOOKUP_TYPES, OPERATION_TYPES }
